import { Grid, Skeleton } from "@mui/material";

const ListSkeleton = () => {
  return (
    <>
      <Grid item xs={12} md={9}>
        <Skeleton
          animation="wave"
          height={150}
          width={"100%"}
          sx={{ mt: -4 }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <Skeleton
          animation="wave"
          height={150}
          width={"100%"}
          sx={{ mt: -4 }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <Skeleton
          animation="wave"
          height={150}
          width={"100%"}
          sx={{ mt: -4 }}
        />
      </Grid>
    </>
  );
};

export default ListSkeleton;
